<ng-container *transloco="let t; read: scope">
  <div class="absolute left-3 top-3 z-10 bg-white">
    @if (useHref && href) {
      <a [href]="href" [target]="target" mat-stroked-button color="primary" rel="nofollow" data-id="view-map">
        <rma-icon glyph="open_in_new" />
        <span class="truncate">{{ t('button') }}</span>
      </a>
    } @else {
      <button
        [queryParams]="mapUrlParams"
        [routerLink]="mapUrl"
        [target]="target"
        mat-stroked-button
        type="button"
        color="primary"
        rel="nofollow"
        data-id="view-map">
        <rma-icon glyph="open_in_new" />
        <span class="truncate">{{ t('button') }}</span>
      </button>
    }
  </div>
</ng-container>

@if (markers$ && markers$ | async; as markers) {
  @if (staticMapUrl || markers.length) {
    <rma-static-google-map class="relative" [markers]="markers" [config]="mapConfig" [staticMapUrl]="staticMapUrl" />
  } @else {
    <img
      class="rounded-lg object-none"
      [src]="'/maps/map-placeholder.svg' | staticImageUrl"
      [style.max-width.px]="mapConfig.width"
      [style.max-height.px]="mapConfig.height"
      alt="map placeholder"
      aria-hidden="true" />
  }
} @else {
  <img
    class="rounded-lg object-none"
    [src]="'/maps/map-placeholder.svg' | staticImageUrl"
    [style.max-width.px]="mapConfig.width"
    [style.max-height.px]="mapConfig.height"
    alt="map placeholder"
    aria-hidden="true" />
}
